import { createSlice } from "@reduxjs/toolkit";
import { ReduxState } from "../../redux/types";

const initialState = {
  status: ReduxState.INIT,
  questionFAQ: {},
  listProducts: [],
  listSurveys: [],
  pointHistories: [],
  totalPoints: 0,
  listNotifications: [],
  listExchaceHistory: [],
  detailProductExchance: {},
  exchanged: {},
  listReports: [],
  mfaStatus: ReduxState.INIT,
  mfaErrorMessage: "",
  mfaMailStatus: ReduxState.INIT,
  mfaMailErrorMessage: "",
  verifyMailStatus: ReduxState.INIT,
  verifyMailErrorMessage: "",
  verifySmsStatus: ReduxState.INIT,
  verifySmsErrorMessage: "",
  mfaRoutingState: null,
}

const myPointSlice = createSlice({
  name: "myPointSlice",
  initialState,
  reducers: {
    makeQuestion: (state, action) => {
      state.status = ReduxState.SUCCESS
      state.questionFAQ = action.payload
    },

    // 指示書（遷移先情報）をセットする
    setMfaRoutingState: (state, action) => {
      state.mfaRoutingState = action.payload;
    },
    // 指示書をクリアする
    clearMfaRoutingState: (state) => {
      state.mfaRoutingState = null;
    },

    // MFA Sms関連
    sendMfaSms: (state, action) => {
      // 画面で「送信」が押された瞬間（APIリクエスト中）
      state.mfaStatus = ReduxState.INIT; 
      state.mfaErrorMessage = ""; // クリア
    },
    sendMfaSmsSuccess: (state, action) => {
      // SMS送信APIが成功したとき
      state.mfaStatus = ReduxState.SUCCESS;
      state.mfaErrorMessage = ""; // クリア
    },
    sendMfaSmsFailed: (state, action) => {
      // SMS送信APIが失敗したとき
      state.mfaStatus = ReduxState.ERROR;
      state.mfaErrorMessage = action.payload || "認証コードの送信に失敗しました。";
    },
    resetMfaStatus: (state) => {
      // 画面を離れるときなどにステータスを初期化したい場合用
      state.mfaStatus = ReduxState.INIT;
      state.mfaErrorMessage = ""; // クリア
      state.mfaMailStatus = ReduxState.INIT;
      state.mfaMailErrorMessage = "";
      state.verifyMailStatus = ReduxState.INIT;
      state.verifyMailErrorMessage = "";
      state.verifySmsStatus = ReduxState.INIT;
      state.verifySmsErrorMessage = "";
    },

    // MFA Mail関連
    sendMfaMail: (state, action) => {
      state.mfaMailStatus = ReduxState.INIT; 
      state.mfaMailErrorMessage = "";
    },
    sendMfaMailSuccess: (state, action) => {
      state.mfaMailStatus = ReduxState.SUCCESS;
      state.mfaMailErrorMessage = "";
    },
    sendMfaMailFailed: (state, action) => {
      state.mfaMailStatus = ReduxState.ERROR;
      state.mfaMailErrorMessage = action.payload || "メール認証コードの送信に失敗しました。";
    },

    // MFA メール認証コード検証
    verifyMfaMail: (state, action) => {
      state.verifyMailStatus = ReduxState.INIT;
      state.verifyMailErrorMessage = "";
    },
    verifyMfaMailSuccess: (state, action) => {
      state.verifyMailStatus = ReduxState.SUCCESS;
      state.verifyMailErrorMessage = "";
    },
    verifyMfaMailFailed: (state, action) => {
      state.verifyMailStatus = ReduxState.ERROR;
      state.verifyMailErrorMessage = action.payload || "認証に失敗しました。";
    },

    // MFA SMS認証コード検証
    verifyMfaSms: (state, action) => {
      state.verifySmsStatus = ReduxState.INIT;
      state.verifySmsErrorMessage = "";
    },
    verifyMfaSmsSuccess: (state, action) => {
      state.verifySmsStatus = ReduxState.SUCCESS;
      state.verifySmsErrorMessage = "";
    },
    verifyMfaSmsFailed: (state, action) => {
      state.verifySmsStatus = ReduxState.ERROR;
      state.verifySmsErrorMessage = action.payload || "認証に失敗しました。";
    },

    listProducts: (state, action) => {
      state.status = ReduxState.INIT
    },
    listProductsSuccess: (state, action) => {
      state.status = ReduxState.SUCCESS
      state.listProducts = action.payload
    },
    listProductsFailed: (state) => {
      state.listProducts = []
      state.status = ReduxState.ERROR;
    },
    listSurveyByMember: (state, action) => {
      state.status = ReduxState.INIT
    },
    listSurveyByMemberSuccess: (state, action) => {
      state.status = ReduxState.SUCCESS
      state.listSurveys = action.payload
    },
    listSurveyByMemberFailed: (state) => {
      state.status = ReduxState.ERROR;
      state.listSurveys = []
    },
    pointHistoryByMember: (state, action) => {
      state.status = ReduxState.INIT
    },
    pointHistoryByMemberSuccess: (state, action) => {
      state.status = ReduxState.SUCCESS
      state.pointHistories = action.payload.point_histories
      state.totalPoints = action.payload.total_points
    },
    pointHistoryByMemberFailed: (state) => {
      state.pointHistories = []
      state.totalPoints = 0
      state.status = ReduxState.ERROR;
    },
    listNotificationByMember: (state, action) => {
      state.status = ReduxState.INIT
    },
    listNotificationByMemberSuccess: (state, action) => {
      state.status = ReduxState.SUCCESS
      state.listNotifications = action.payload
    },
    listNotificationByMemberFailed: (state) => {
      state.listNotifications = []
      state.status = ReduxState.ERROR;
    },
    listExchanceHistory: (state, action) => {
      state.status = ReduxState.INIT
    },
    listExchanceHistorySuccess: (state, action) => {
      state.status = ReduxState.SUCCESS
      state.listExchaceHistory = action.payload
    },
    listExchanceHistoryFailed: (state) => {
      state.listExchaceHistory = []
      state.status = ReduxState.ERROR;
    },
    fetchDetailProduct: (state, action) => {
      state.detailProductExchance = action.payload
      state.status = ReduxState.SUCCESS;
    },
    pointExchanged: (state, action) => {
      state.exchanged = action.payload
      state.status = ReduxState.SUCCESS;
    },
    finishPointExchanged: (state, action) => {
      state.status = ReduxState.INIT;
    },
    finishPointExchangedSuccess: (state, action) => {
      state.status = ReduxState.SUCCESS;
      state.exchanged = {}
      state.detailProductExchance = {}
    },
    finishPointExchangedFailed: (state, action) => {
      state.status = ReduxState.ERROR;
    },
    finishPointDonated: (state, action) => {
      state.status = ReduxState.INIT;
    },
    finishPointDonatedSuccess: (state, action) => {
      state.status = ReduxState.SUCCESS;
      state.exchanged = {}
      state.detailProductExchance = {}
    },
    finishPointDonatedFailed: (state, action) => {
      state.status = ReduxState.ERROR;
    },
    createInquiry: (state, action) => {
      state.status = ReduxState.INIT;
    },
    createInquirySuccess: (state, action) => {
      state.status = ReduxState.SUCCESS;
      state.questionFAQ = {}
    },
    createInquiryFailed: (state, action) => {
      state.status = ReduxState.ERROR;
    },
    resetListSurveys: (state, action) => {
      state.listSurveys = [];
    },
    listReports: (state, action) => {
      state.status = ReduxState.INIT
    },
    listReportsSuccess: (state, action) => {
      state.status = ReduxState.SUCCESS
      state.listReports = action.payload
    },
    listReportsFailed: (state) => {
      state.listReports = []
      state.status = ReduxState.ERROR;
    },
  },
});

export const {
  makeQuestion,
  listProducts, listProductsSuccess, listProductsFailed,
  listSurveyByMember, listSurveyByMemberSuccess, listSurveyByMemberFailed,
  pointHistoryByMember, pointHistoryByMemberSuccess, pointHistoryByMemberFailed,
  listNotificationByMember, listNotificationByMemberSuccess, listNotificationByMemberFailed,
  listExchanceHistory, listExchanceHistoryFailed, listExchanceHistorySuccess,
  fetchDetailProduct, pointExchanged,
  finishPointExchanged, finishPointExchangedFailed, finishPointExchangedSuccess,
  finishPointDonated, finishPointDonatedFailed, finishPointDonatedSuccess,
  createInquiry, createInquiryFailed, createInquirySuccess, resetListSurveys,
  listReports, listReportsSuccess, listReportsFailed,
  sendMfaSms, sendMfaSmsSuccess, sendMfaSmsFailed, resetMfaStatus,
  sendMfaMail, sendMfaMailSuccess, sendMfaMailFailed,
  verifyMfaMail, verifyMfaMailSuccess, verifyMfaMailFailed,
  verifyMfaSms, verifyMfaSmsSuccess, verifyMfaSmsFailed,
  setMfaRoutingState, clearMfaRoutingState,
} = myPointSlice.actions;

// selector
export const selectListProducts = state => state.myPoint.listProducts
export const selectListNotifications = state => state.myPoint.listNotifications
export const selectPointHistories = state => state.myPoint.pointHistories
export const selectTotalPoints = state => state.myPoint.totalPoints
export const selectListSurveys = state => state.myPoint.listSurveys
export const selectListExchances = state => state.myPoint.listExchaceHistory
export const selectDetailProductExchance = state => state.myPoint.detailProductExchance
export const selectExchanged = state => state.myPoint.exchanged
export const selectStatus = state => state.myPoint.status;
export const selectListReports = state => state.myPoint.listReports
export const selectMfaStatus = state => state.myPoint.mfaStatus;
export const selectMfaErrorMessage = state => state.myPoint.mfaErrorMessage;
export const selectMfaMailStatus = state => state.myPoint.mfaMailStatus;
export const selectMfaMailErrorMessage = state => state.myPoint.mfaMailErrorMessage;
export const selectVerifyMailStatus = state => state.myPoint.verifyMailStatus;
export const selectVerifyMailErrorMessage = state => state.myPoint.verifyMailErrorMessage;
export const selectVerifySmsStatus = state => state.myPoint.verifySmsStatus;
export const selectVerifySmsErrorMessage = state => state.myPoint.verifySmsErrorMessage;
export const selectMfaRoutingState = state => state.myPoint.mfaRoutingState;

export default myPointSlice.reducer;